import React from 'react';
import { BookOpen, Wrench, FileText, FileDown, HelpCircle, Info, ArrowUpRight } from 'lucide-react';
const resources = [{
  title: 'See how different pumps work and their features.',
  href: '596.html',
  icon: BookOpen,
  type: 'Guide'
}, {
  title: 'Troubleshoot Your Pump',
  href: 'https://www.clrmarine.com/544.html',
  icon: Wrench,
  type: 'Tool'
}, {
  title: 'Jabsco Impeller Replacement Guide',
  href: 'https://www.clrmarine.com/576.html',
  icon: FileText,
  type: 'Article'
}, {
  title: 'Globe Run-Dry Impeller Replacement Chart',
  href: 'https://www.clrmarine.com/uploaded/files/Globe%20Impeller%20Replacement.pdf',
  icon: FileDown,
  type: 'PDF'
}, {
  title: 'Fill out the form',
  href: 'https://www.clrmarine.com/531.html',
  icon: HelpCircle,
  type: 'Help Request'
}, {
  title: 'Primetime Pump Information',
  href: '673.html',
  icon: Info,
  type: 'Info'
}];
export function Resources() {
  return <section className="w-full bg-marine-navy text-white" data-id="element-138">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-14" data-id="element-139">
        <div className="mb-6" data-id="element-140">
          <h2 className="text-2xl md:text-3xl font-bold mb-2" data-id="element-141">
            Pump Help & Resources
          </h2>
          <p className="text-slate-300 max-w-2xl" data-id="element-142">
            Guides, charts, and troubleshooting tools to help you maintain or
            choose the right pump.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-143">
          {resources.map(r => <a key={r.title} href={r.href} className="group flex flex-col bg-white/5 border border-white/10 rounded-lg p-5 hover:bg-white/10 hover:border-marine-cyan/50 transition-all duration-150" data-id="element-144">
              <div className="flex items-center justify-between mb-3" data-id="element-145">
                <div className="bg-marine-blue/30 p-2 rounded-md text-marine-cyan group-hover:bg-marine-cyan group-hover:text-marine-navy transition-colors duration-150" data-id="element-146">
                  <r.icon className="w-5 h-5" data-id="element-147" />
                </div>
                <span className="text-[10px] font-semibold uppercase tracking-wider text-slate-400" data-id="element-148">
                  {r.type}
                </span>
              </div>
              <h3 className="text-base font-semibold text-slate-100 group-hover:text-white leading-snug flex items-start justify-between gap-2" data-id="element-149">
                <span data-id="element-150">{r.title}</span>
                <ArrowUpRight className="w-4 h-4 flex-shrink-0 mt-0.5 text-slate-400 group-hover:text-marine-cyan transition-colors" data-id="element-151" />
              </h3>
            </a>)}
        </div>
      </div>
    </section>;
}